module.exports = __webpack_public_path__ + "assets/images/UNFIT20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/UNFIT20.png
// module id = 1442
// module chunks = 1